import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Directive, Input, HostBinding, Output, Component, ChangeDetectionStrategy, ViewChild, HostListener, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import * as i2 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import * as i3 from '@readcube/ngx-contextmenu';
import { ReadCubeContextMenuModule } from '@readcube/ngx-contextmenu';
import * as i1$2 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/pro-light-svg-icons';

class SortByFieldPipe {
    transform(array, field) {
        (array || []).sort((a, b) => {
            a = a[field];
            b = b[field];
            if (a < b) {
                return -1;
            }
            else if (a > b) {
                return 1;
            }
            else {
                return 0;
            }
        });
        return array;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SortByFieldPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: SortByFieldPipe, name: "sortByField" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SortByFieldPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sortByField'
                }]
        }] });

class ResizeHandleDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.widthChange = new EventEmitter();
        this.dragUnlisten = () => undefined;
        this.stopUnlisten = () => undefined;
    }
    stopDrag() {
        this.dragUnlisten();
        this.stopUnlisten();
    }
    startDrag(event) {
        const rect = this.el.nativeElement.getBoundingClientRect();
        const offsetLeft = rect.left + window.scrollX;
        this.dragUnlisten = this.renderer.listen(window, 'mousemove', event => {
            this.width = event.pageX - offsetLeft;
            if (this.width < this.minWidth) {
                this.width = this.minWidth;
            }
            else if (this.width > this.maxWidth) {
                this.width = this.maxWidth;
            }
            this.widthChange.next(this.width);
        });
        this.stopUnlisten = this.renderer.listen(window, 'mouseup', () => {
            this.stopDrag();
        });
    }
    ngAfterViewInit() {
        this.renderer.listen(this.resizeHanle, 'mousedown', (event) => {
            this.startDrag(event);
            event.stopPropagation();
        });
    }
    ngOnDestroy() {
        this.stopDrag();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ResizeHandleDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: ResizeHandleDirective, selector: "[resizeHanle]", inputs: { width: "width", minWidth: "minWidth", maxWidth: "maxWidth", resizeHanle: "resizeHanle" }, outputs: { widthChange: "widthChange" }, host: { properties: { "style.width.px": "this.width" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ResizeHandleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[resizeHanle]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { width: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.width.px']
            }], widthChange: [{
                type: Output
            }], minWidth: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], resizeHanle: [{
                type: Input
            }] } });

class DataViewListRowComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewListRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: DataViewListRowComponent, selector: "data-view-list-row", inputs: { item: "item", even: "even", selected: "selected", highlighted: "highlighted", templateRef: "templateRef" }, host: { properties: { "class.even": "this.even", "class.selected": "this.selected", "class.highlighted": "this.highlighted" } }, ngImport: i0, template: "<ng-template [ngTemplateOutlet]=\"templateRef\" [ngTemplateOutletContext]=\"{ item: item, selected: selected }\"></ng-template>\n", styles: [":host{display:block}\n"], dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewListRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'data-view-list-row', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template [ngTemplateOutlet]=\"templateRef\" [ngTemplateOutletContext]=\"{ item: item, selected: selected }\"></ng-template>\n", styles: [":host{display:block}\n"] }]
        }], propDecorators: { item: [{
                type: Input
            }], even: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.even']
            }], selected: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.selected']
            }], highlighted: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.highlighted']
            }], templateRef: [{
                type: Input
            }] } });

function debounce(func, wait, immediate) {
    let timeout;
    return function () {
        let context = this, args = arguments;
        let later = function () {
            timeout = null;
            if (!immediate)
                func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow)
            func.apply(context, args);
    };
}
class DataViewListComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.items = [];
        this.itemSize = 50; // Set to calculated outer height of the row element.
        this.selected = [];
        this.highlighted = [];
        this.hasFocus = false;
        this.multiselect = true;
        this.open = new EventEmitter();
        this.selectedChange = new EventEmitter();
        this.highlightedChange = new EventEmitter();
        this.hasFocusChange = new EventEmitter();
        this.loadNext = new EventEmitter();
        this.cursor = -1;
        this.itemIds = [];
        this.selectedItemIds = [];
        this.highlightedItemIds = [];
    }
    ngOnInit() {
        setTimeout(() => this.checkViewLoaded(), 2000);
        setTimeout(() => this.scrollIntoView(), 1000);
        this.resizeObserver = new ResizeObserver(debounce(() => {
            this.checkViewLoaded();
            this.virtualScrollViewport.checkViewportSize();
        }, 2000, false));
        this.resizeObserver.observe(this.virtualScrollViewport.elementRef.nativeElement);
    }
    ngOnDestroy() {
        this.resizeObserver.unobserve(this.virtualScrollViewport.elementRef.nativeElement);
    }
    ngOnChanges(changes) {
        if (changes.items && changes.items.currentValue) {
            const items = changes.items.currentValue;
            this.itemIds = items.map(item => item.id);
        }
        if (changes.selected && changes.selected.currentValue) {
            const selected = changes.selected.currentValue;
            this.selectedItemIds = selected.map(item => item.id);
        }
        if (changes.highlighted && changes.highlighted.currentValue) {
            const highlighted = changes.highlighted.currentValue;
            this.highlightedItemIds = highlighted.map(item => item.id);
        }
    }
    loadNextBatch(index) {
        const bottomOffset = this.virtualScrollViewport.measureScrollOffset('bottom');
        if (bottomOffset < 200 && this.items) {
            this.loadNext.emit({ skip: this.items.length });
        }
    }
    checkViewLoaded() {
        const n = this.items ? this.items.length : 0;
        const elementRef = this.elementRef.nativeElement;
        if (elementRef.offsetHeight > n * this.itemSize) {
            this.loadNext.emit({ skip: n });
        }
    }
    scrollIntoView() {
        if (this.selected.length) {
            this.scrollTo(this.selected[0], 'smooth');
        }
    }
    onClick(event, item) {
        this.updateFocus(true);
        if (event.button != 0) {
            return;
        }
        const index = this.items.indexOf(item);
        // Checking selection types
        if (event.shiftKey) {
            // Range selection
            this.clearSelection();
            this.selectRange(this.cursor, index);
        }
        else if (event.ctrlKey || event.metaKey) {
            // One by one selection
            if (this.isItemSelected(item)) {
                this.unselectItem(item);
            }
            else {
                this.selectItem(item);
            }
            this.cursor = index;
        }
        else {
            // Normal selection
            this.clearSelection();
            if (!this.isItemSelected(item)) {
                this.scrollTo(item, 'smooth');
                this.selectItem(item);
            }
            this.cursor = index;
        }
        this.selectedChange.emit(this.selected);
    }
    onDblClick(event, item) {
        this.open.emit(item);
    }
    onContextMenu(event, item) {
        // right-click on already selected item triggers selection event
        if (this.isItemSelected(item)) {
            this.selectedChange.emit(this.selected);
        }
        else {
            //right-click on any non-selected item triggers highlight event
            this.highlightedChange.emit([item]);
        }
        event.preventDefault();
    }
    onKeyDown(event) {
        let item;
        if (!this.hasFocus) {
            return;
        }
        if (this.cursor < 0 && this.selected.length > 0) {
            this.cursor = this.items.indexOf(this.selected[0]);
        }
        switch (event.key) {
            case 'ArrowUp':
                if (this.cursor <= 0) {
                    break;
                }
                this.cursor--;
                item = this.items[this.cursor];
                if (!event.shiftKey) {
                    this.clearSelection();
                }
                if (!this.isItemSelected(item)) {
                    this.scrollTo(item, 'smooth');
                    this.selectItem(item);
                }
                this.selectedChange.emit(this.selected);
                event.preventDefault();
                break;
            case 'ArrowDown':
                if (this.cursor >= this.items.length - 1) {
                    break;
                }
                this.cursor++;
                item = this.items[this.cursor];
                if (!event.shiftKey) {
                    this.clearSelection();
                }
                if (!this.isItemSelected(item)) {
                    this.scrollTo(item, 'smooth');
                    this.selectItem(item);
                }
                this.selectedChange.emit(this.selected);
                event.preventDefault();
                break;
        }
    }
    onDocumentClick(event) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.updateFocus(false);
        }
    }
    onBlur() {
        this.updateFocus(false);
    }
    selectItem(item) {
        if (!this.multiselect) {
            this.clearSelection();
        }
        if (item && !this.isItemSelected(item)) {
            this.selected.push(item);
            this.selectedItemIds.push(item.id);
        }
    }
    unselectItem(item) {
        const i = this.selected.indexOf(item);
        const j = this.selectedItemIds.indexOf(item.id);
        this.selected.splice(i, 1);
        this.selectedItemIds.splice(j, 1);
    }
    selectRange(start, stop) {
        if (!this.multiselect) {
            this.selectItem(this.items[stop]);
        }
        else {
            this.genRange(Math.max(start, 0), stop).forEach(index => {
                this.selectItem(this.items[index]);
            });
        }
    }
    clearSelection() {
        this.selected.splice(0);
        this.selectedItemIds.splice(0);
    }
    isItemSelected(item) {
        return item && this.selectedItemIds.indexOf(item.id) !== -1;
    }
    isItemHighlighted(item) {
        return item && this.highlightedItemIds.indexOf(item.id) !== -1;
    }
    isItemEven(item) {
        return item && this.itemIds.indexOf(item.id) % 2 === 0;
    }
    trackByFn(index, item) {
        return item.id;
    }
    genRange(start, stop) {
        if (stop === undefined) {
            stop = start;
        }
        const range = [];
        const step = stop > start ? 1 : -1;
        const length = Math.max(Math.ceil((stop - start) / step), 0);
        for (let i = 0; i <= length; i++, start += step) {
            range.push(start);
        }
        return range;
    }
    scrollTo(item, behavior) {
        if (!this.items)
            return;
        const index = this.items.indexOf(item);
        const offsetTop = this.virtualScrollViewport.measureScrollOffset('top');
        const offsetBottom = offsetTop + this.virtualScrollViewport.getViewportSize();
        if (index < Math.ceil(offsetTop / this.itemSize)) {
            this.virtualScrollViewport.scrollToIndex(index, behavior);
        }
        if (index >= Math.floor(offsetBottom / this.itemSize)) {
            this.virtualScrollViewport.scrollToIndex(index, behavior);
        }
    }
    updateFocus(value) {
        setTimeout(() => {
            this.hasFocus = value;
            this.hasFocusChange.next(value);
        }, 10);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewListComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: DataViewListComponent, selector: "data-view-list", inputs: { items: "items", itemSize: "itemSize", selected: "selected", highlighted: "highlighted", hasFocus: "hasFocus", multiselect: "multiselect", templateRef: "templateRef" }, outputs: { open: "open", selectedChange: "selectedChange", highlightedChange: "highlightedChange", hasFocusChange: "hasFocusChange", loadNext: "loadNext" }, host: { listeners: { "window:keydown": "onKeyDown($event)", "document:click": "onDocumentClick($event)", "document:blur": "onBlur()" } }, viewQueries: [{ propertyName: "virtualScrollViewport", first: true, predicate: CdkVirtualScrollViewport, descendants: true, static: true }], usesOnChanges: true, ngImport: i0, template: "<cdk-virtual-scroll-viewport\n  [itemSize]=\"itemSize\"\n  (scrolledIndexChange)=\"loadNextBatch($event)\"\n  class=\"viewport papers-scrollbar\">\n  <data-view-list-row\n    *cdkVirtualFor=\"let item of items; trackBy: trackByFn\"\n    [item]=\"item\"\n    [selected]=\"isItemSelected(item)\"\n    [highlighted]=\"isItemHighlighted(item)\"\n    [templateRef]=\"templateRef\"\n    [even]=\"isItemEven(item)\"\n    (click)=\"onClick($event, item)\"\n    (dblclick)=\"onDblClick($event, item)\"\n    (contextmenu)=\"onContextMenu($event, item)\">\n  </data-view-list-row>\n  <ng-content></ng-content>\n</cdk-virtual-scroll-viewport>\n", styles: [":host{display:flex;flex-direction:column;position:absolute;height:100%;width:100%}.viewport{height:100%;width:100%}\n"], dependencies: [{ kind: "directive", type: i1$1.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i1$1.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i1$1.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "component", type: DataViewListRowComponent, selector: "data-view-list-row", inputs: ["item", "even", "selected", "highlighted", "templateRef"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'data-view-list', changeDetection: ChangeDetectionStrategy.OnPush, template: "<cdk-virtual-scroll-viewport\n  [itemSize]=\"itemSize\"\n  (scrolledIndexChange)=\"loadNextBatch($event)\"\n  class=\"viewport papers-scrollbar\">\n  <data-view-list-row\n    *cdkVirtualFor=\"let item of items; trackBy: trackByFn\"\n    [item]=\"item\"\n    [selected]=\"isItemSelected(item)\"\n    [highlighted]=\"isItemHighlighted(item)\"\n    [templateRef]=\"templateRef\"\n    [even]=\"isItemEven(item)\"\n    (click)=\"onClick($event, item)\"\n    (dblclick)=\"onDblClick($event, item)\"\n    (contextmenu)=\"onContextMenu($event, item)\">\n  </data-view-list-row>\n  <ng-content></ng-content>\n</cdk-virtual-scroll-viewport>\n", styles: [":host{display:flex;flex-direction:column;position:absolute;height:100%;width:100%}.viewport{height:100%;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { items: [{
                type: Input
            }], itemSize: [{
                type: Input
            }], selected: [{
                type: Input
            }], highlighted: [{
                type: Input
            }], hasFocus: [{
                type: Input
            }], multiselect: [{
                type: Input
            }], templateRef: [{
                type: Input
            }], open: [{
                type: Output
            }], selectedChange: [{
                type: Output
            }], highlightedChange: [{
                type: Output
            }], hasFocusChange: [{
                type: Output
            }], loadNext: [{
                type: Output
            }], virtualScrollViewport: [{
                type: ViewChild,
                args: [CdkVirtualScrollViewport, { static: true }]
            }], onKeyDown: [{
                type: HostListener,
                args: ['window:keydown', ['$event']]
            }], onDocumentClick: [{
                type: HostListener,
                args: ['document:click', ['$event']]
            }], onBlur: [{
                type: HostListener,
                args: ['document:blur']
            }] } });

class DataViewTableHeadComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.columnsChange = new EventEmitter();
        this.headClick = new EventEmitter();
        this.columnCount = 0;
    }
    ngOnChanges(changes) {
        if ('columns' in changes) {
            this.columnCount = this.columns.filter(c => !c.hidden).length;
        }
    }
    onOrderChange(event) {
        const visible = this.columns.filter(c => !c.hidden);
        const previousIndex = visible[event.previousIndex].index;
        const currentIndex = visible[event.currentIndex].index;
        moveItemInArray(this.columns, previousIndex, currentIndex);
        this.columns.forEach((c, i) => c.index = i);
        this.columnsChange.emit(this.columns);
    }
    onWidthChange(width) {
        this.columnsChange.emit(this.columns);
    }
    onHeadClick(column) {
        this.headClick.emit(column);
    }
    stopEvent(event) {
        event.stopPropagation();
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableHeadComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: DataViewTableHeadComponent, selector: "data-view-table-head", inputs: { columns: "columns" }, outputs: { columnsChange: "columnsChange", headClick: "headClick" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"sortable\"\n  cdkDropList\n  cdkDropListLockAxis=\"x\"\n  cdkDropListOrientation=\"horizontal\"\n  (cdkDropListDropped)=\"onOrderChange($event)\"\n  draggable=\"true\" (dragstart)=\"stopEvent($event)\">\n\n  <div *ngIf=\"columnCount == 0\" class=\"nocol\">\n    Right click here to add columns...\n  </div>\n\n  <ng-container *ngFor=\"let c of columns | sortByField:'index'\">\n    <div class=\"cell\"\n      *ngIf=\"!c.hidden\"\n      cdkDrag\n      [cdkDragData]=\"c\"\n      cdkDragBoundary=\".sortable\"\n      [resizeHanle]=\"resizeHandle\"\n      [minWidth]=\"c.minWidth\"\n      [(width)]=\"c.width\"\n      (widthChange)=\"onWidthChange($event)\"\n      [ngStyle]=\"c.headStyle\"\n      (click)=\"onHeadClick(c)\">\n\n      <div class=\"content\" cdkDragHandle>\n        <ng-template [ngIf]=\"!c.headTemplateRef\">{{c.title}}</ng-template>\n\n        <ng-template [ngIf]=\"c.headTemplateRef\"\n          [ngTemplateOutlet]=\"c.headTemplateRef\"\n          [ngTemplateOutletContext]=\"{ column: c }\">\n        </ng-template>\n      </div>\n\n      <div class=\"sort-icon\" *ngIf=\"c.sorted\">\n        <fa-icon [icon]=\"['fal', c.sorted == 'asc' ? 'chevron-down' : 'chevron-up']\" size=\"xs\"></fa-icon>\n      </div>\n\n      <div class=\"resize-handle\" #resizeHandle (click)=\"stopEvent($event)\"></div>\n    </div>\n  </ng-container>\n\n\n</div>\n", styles: [":host{display:block;-webkit-user-select:none;user-select:none}.sortable{display:flex;flex-direction:row;min-height:27px}.cell{display:flex;flex-direction:row;resize:horizontal;flex:0 0 auto;line-height:28px;font-size:12px;font-weight:600;align-items:center;justify-content:space-between;cursor:move}.cell .content{flex:1 1 auto;padding:2px 0 2px 5px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.cell .sort-icon{flex:0 0 5px;margin:2px}.cell .sort-icon i{vertical-align:middle}.cell .resize-handle{flex:0 0 10px;margin:3px 0;cursor:col-resize;height:75%}.nocol{line-height:27px;vertical-align:middle;text-align:center;width:100%}.cdk-drag-preview{box-sizing:border-box;opacity:.6;border-radius:2px;font-size:inherit;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.sortable.cdk-drop-list-dragging .cell:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "directive", type: i2.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i2.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i2.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "component", type: i1$2.FaIconComponent, selector: "fa-icon", inputs: ["icon", "title", "animation", "spin", "pulse", "mask", "styles", "flip", "size", "pull", "border", "inverse", "symbol", "rotate", "fixedWidth", "classes", "transform", "a11yRole"] }, { kind: "directive", type: ResizeHandleDirective, selector: "[resizeHanle]", inputs: ["width", "minWidth", "maxWidth", "resizeHanle"], outputs: ["widthChange"] }, { kind: "pipe", type: SortByFieldPipe, name: "sortByField" }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableHeadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'data-view-table-head', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"sortable\"\n  cdkDropList\n  cdkDropListLockAxis=\"x\"\n  cdkDropListOrientation=\"horizontal\"\n  (cdkDropListDropped)=\"onOrderChange($event)\"\n  draggable=\"true\" (dragstart)=\"stopEvent($event)\">\n\n  <div *ngIf=\"columnCount == 0\" class=\"nocol\">\n    Right click here to add columns...\n  </div>\n\n  <ng-container *ngFor=\"let c of columns | sortByField:'index'\">\n    <div class=\"cell\"\n      *ngIf=\"!c.hidden\"\n      cdkDrag\n      [cdkDragData]=\"c\"\n      cdkDragBoundary=\".sortable\"\n      [resizeHanle]=\"resizeHandle\"\n      [minWidth]=\"c.minWidth\"\n      [(width)]=\"c.width\"\n      (widthChange)=\"onWidthChange($event)\"\n      [ngStyle]=\"c.headStyle\"\n      (click)=\"onHeadClick(c)\">\n\n      <div class=\"content\" cdkDragHandle>\n        <ng-template [ngIf]=\"!c.headTemplateRef\">{{c.title}}</ng-template>\n\n        <ng-template [ngIf]=\"c.headTemplateRef\"\n          [ngTemplateOutlet]=\"c.headTemplateRef\"\n          [ngTemplateOutletContext]=\"{ column: c }\">\n        </ng-template>\n      </div>\n\n      <div class=\"sort-icon\" *ngIf=\"c.sorted\">\n        <fa-icon [icon]=\"['fal', c.sorted == 'asc' ? 'chevron-down' : 'chevron-up']\" size=\"xs\"></fa-icon>\n      </div>\n\n      <div class=\"resize-handle\" #resizeHandle (click)=\"stopEvent($event)\"></div>\n    </div>\n  </ng-container>\n\n\n</div>\n", styles: [":host{display:block;-webkit-user-select:none;user-select:none}.sortable{display:flex;flex-direction:row;min-height:27px}.cell{display:flex;flex-direction:row;resize:horizontal;flex:0 0 auto;line-height:28px;font-size:12px;font-weight:600;align-items:center;justify-content:space-between;cursor:move}.cell .content{flex:1 1 auto;padding:2px 0 2px 5px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.cell .sort-icon{flex:0 0 5px;margin:2px}.cell .sort-icon i{vertical-align:middle}.cell .resize-handle{flex:0 0 10px;margin:3px 0;cursor:col-resize;height:75%}.nocol{line-height:27px;vertical-align:middle;text-align:center;width:100%}.cdk-drag-preview{box-sizing:border-box;opacity:.6;border-radius:2px;font-size:inherit;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.sortable.cdk-drop-list-dragging .cell:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { columns: [{
                type: Input
            }], columnsChange: [{
                type: Output
            }], headClick: [{
                type: Output
            }] } });

class DataViewTableRowComponent {
    ngOnChanges(changes) {
        if (!changes.columns) {
            return;
        }
        this._columns = this.columns.slice().filter(c => !c.hidden)
            .sort((a, b) => a.index < b.index ? -1 : 1);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableRowComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: DataViewTableRowComponent, selector: "data-view-table-row", inputs: { item: "item", columns: "columns", even: "even", selected: "selected", highlighted: "highlighted" }, host: { properties: { "class.even": "this.even", "class.selected": "this.selected", "class.highlighted": "this.highlighted" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"cell\" *ngFor=\"let c of _columns\" [style.width]=\"c.width + 'px'\" [ngStyle]=\"c.style\">\n  <ng-template [ngTemplateOutlet]=\"c.templateRef\" [ngTemplateOutletContext]=\"{ column: c, item, selected }\"></ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:row;-webkit-user-select:none;user-select:none}.cell{display:block;flex:0 0 auto;padding:2px 5px;min-height:32px;line-height:28px;font-size:13px;letter-spacing:-.13px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;cursor:default}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'data-view-table-row', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cell\" *ngFor=\"let c of _columns\" [style.width]=\"c.width + 'px'\" [ngStyle]=\"c.style\">\n  <ng-template [ngTemplateOutlet]=\"c.templateRef\" [ngTemplateOutletContext]=\"{ column: c, item, selected }\"></ng-template>\n</div>\n", styles: [":host{display:flex;flex-direction:row;-webkit-user-select:none;user-select:none}.cell{display:block;flex:0 0 auto;padding:2px 5px;min-height:32px;line-height:28px;font-size:13px;letter-spacing:-.13px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;cursor:default}\n"] }]
        }], propDecorators: { item: [{
                type: Input
            }], columns: [{
                type: Input
            }], even: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.even']
            }], selected: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.selected']
            }], highlighted: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.highlighted']
            }] } });

class DataViewTableComponent extends DataViewListComponent {
    get tableWidth() {
        return this.columns.filter(c => !c.hidden).reduce((a, b) => a + b.width, 0);
    }
    constructor(elementRef, renderer) {
        super(elementRef);
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.itemSize = 32; // Set to calculated outer height of the row element.
        this.columnsChange = new EventEmitter();
        this.headClick = new EventEmitter();
    }
    ngOnInit() {
        super.ngOnInit();
        const viewportElementRef = this.virtualScrollViewport.elementRef;
        const tableHeadElementRef = this.gridTableHead.elementRef;
        this.unlistenScroll = this.renderer.listen(viewportElementRef.nativeElement, 'scroll', () => {
            const scrollLeft = viewportElementRef.nativeElement.scrollLeft;
            this.renderer.setStyle(tableHeadElementRef.nativeElement, 'margin-left', `-${scrollLeft}px`);
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.unlistenScroll();
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (!changes.columns) {
            return;
        }
        this.defaultColumns = this.columns.slice()
            .filter(col => !col.customField)
            .sort((a, b) => a.title < b.title ? -1 : 1);
        this.customColumns = this.columns.slice()
            .filter(col => !!col.customField)
            .sort((a, b) => a.title < b.title ? -1 : 1);
    }
    onColumnsChange(columns) {
        // Update columns reference to satisfy OnPush update strategy
        // required by ItemsTableHead and ItemsTableRow components.
        this.columns = columns.slice();
        this.columnsChange.emit(columns);
    }
    onHeadClick(column) {
        this.headClick.emit(column);
    }
    toggleColumn(columnId) {
        for (let i = 0; i < this.columns.length; i++) {
            const column = this.columns[i];
            if (column.id === columnId) {
                column.hidden = !column.hidden;
            }
        }
        this.onColumnsChange(this.columns);
    }
    resetColumns() {
        for (let i = 0; i < this.columns.length; i++) {
            const column = this.columns[i];
            column.index = column.defaultIndex;
            column.width = column.defaultWidth;
            column.hidden = column.defaultHidden;
        }
        this.onColumnsChange(this.columns);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: DataViewTableComponent, selector: "data-view-table", inputs: { columns: "columns", itemSize: "itemSize" }, outputs: { columnsChange: "columnsChange", headClick: "headClick" }, viewQueries: [{ propertyName: "gridTableHead", first: true, predicate: DataViewTableHeadComponent, descendants: true, static: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<context-menu #columnsMenu>\n  <ng-template contextMenuItem (execute)=\"resetColumns()\">\n    <span>Reset to Default</span>\n  </ng-template>\n\n  <ng-template contextMenuItem divider=\"true\"></ng-template>\n\n  <ng-template contextMenuItem [subMenu]=\"customColumnsSubMenu\" *ngIf=\"customColumns?.length\">Custom Fields</ng-template>\n  <ng-template contextMenuItem divider=\"true\" *ngIf=\"customColumns?.length\"></ng-template>\n\n  <ng-template *ngFor=\"let c of defaultColumns\" contextMenuItem passive=\"true\">\n    <div class=\"form-check form-switch\" style=\"min-height: auto;\" (click)=\"toggleColumn(c.id)\">\n      <input class=\"form-check-input\" [id]=\"c.id\" [checked]=\"!c.hidden\" type=\"checkbox\">\n      <label class=\"form-check-label\" [for]=\"c.key\">{{c.title}}</label>\n    </div>\n  </ng-template>\n</context-menu>\n\n<context-menu #customColumnsSubMenu>\n  <ng-template *ngFor=\"let c of customColumns\" contextMenuItem passive=\"true\">\n    <div class=\"form-check form-switch\" style=\"min-height: auto;\" (click)=\"toggleColumn(c.id)\">\n      <input class=\"form-check-input\" [id]=\"c.id\" [checked]=\"!c.hidden\" type=\"checkbox\">\n      <label class=\"form-check-label\" [for]=\"c.key\">{{c.title}}</label>\n    </div>\n  </ng-template>\n</context-menu>\n\n\n<data-view-table-head #tableHeadElement\n  [columns]=\"columns\"\n  (columnsChange)=\"onColumnsChange($event)\"\n  (headClick)=\"onHeadClick($event)\"\n  [contextMenu]=\"columnsMenu\"\n  [style.minWidth.px]=\"tableWidth\">\n</data-view-table-head>\n\n\n<cdk-virtual-scroll-viewport\n  [itemSize]=\"itemSize\"\n  (scrolledIndexChange)=\"loadNextBatch($event)\"\n  class=\"viewport papers-scrollbar\">\n  <data-view-table-row\n    *cdkVirtualFor=\"let item of items; trackBy: trackByFn\"\n    [columns]=\"columns\"\n    [item]=\"item\"\n    [selected]=\"isItemSelected(item)\"\n    [highlighted]=\"isItemHighlighted(item)\"\n    [even]=\"isItemEven(item)\"\n    (click)=\"onClick($event, item)\"\n    (dblclick)=\"onDblClick($event, item)\"\n    (contextmenu)=\"onContextMenu($event, item)\">\n  </data-view-table-row>\n  <ng-content></ng-content>\n</cdk-virtual-scroll-viewport>\n", styles: [":host{display:flex;flex-direction:column;position:absolute;height:100%;width:100%}.viewport{height:100%;width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$1.CdkFixedSizeVirtualScroll, selector: "cdk-virtual-scroll-viewport[itemSize]", inputs: ["itemSize", "minBufferPx", "maxBufferPx"] }, { kind: "directive", type: i1$1.CdkVirtualForOf, selector: "[cdkVirtualFor][cdkVirtualForOf]", inputs: ["cdkVirtualForOf", "cdkVirtualForTrackBy", "cdkVirtualForTemplate", "cdkVirtualForTemplateCacheSize"] }, { kind: "component", type: i1$1.CdkVirtualScrollViewport, selector: "cdk-virtual-scroll-viewport", inputs: ["orientation", "appendOnly"], outputs: ["scrolledIndexChange"] }, { kind: "directive", type: i3.ContextMenuAttachDirective, selector: "[contextMenu]", inputs: ["contextMenuSubject", "contextMenu"] }, { kind: "component", type: i3.ContextMenuComponent, selector: "context-menu", inputs: ["menuClass", "autoFocus", "useBootstrap4", "disabled"], outputs: ["close", "open"] }, { kind: "directive", type: i3.ContextMenuItemDirective, selector: "[contextMenuItem]", inputs: ["subMenu", "divider", "enabled", "passive", "visible"], outputs: ["execute"] }, { kind: "component", type: DataViewTableHeadComponent, selector: "data-view-table-head", inputs: ["columns"], outputs: ["columnsChange", "headClick"] }, { kind: "component", type: DataViewTableRowComponent, selector: "data-view-table-row", inputs: ["item", "columns", "even", "selected", "highlighted"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataViewTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'data-view-table', changeDetection: ChangeDetectionStrategy.OnPush, template: "<context-menu #columnsMenu>\n  <ng-template contextMenuItem (execute)=\"resetColumns()\">\n    <span>Reset to Default</span>\n  </ng-template>\n\n  <ng-template contextMenuItem divider=\"true\"></ng-template>\n\n  <ng-template contextMenuItem [subMenu]=\"customColumnsSubMenu\" *ngIf=\"customColumns?.length\">Custom Fields</ng-template>\n  <ng-template contextMenuItem divider=\"true\" *ngIf=\"customColumns?.length\"></ng-template>\n\n  <ng-template *ngFor=\"let c of defaultColumns\" contextMenuItem passive=\"true\">\n    <div class=\"form-check form-switch\" style=\"min-height: auto;\" (click)=\"toggleColumn(c.id)\">\n      <input class=\"form-check-input\" [id]=\"c.id\" [checked]=\"!c.hidden\" type=\"checkbox\">\n      <label class=\"form-check-label\" [for]=\"c.key\">{{c.title}}</label>\n    </div>\n  </ng-template>\n</context-menu>\n\n<context-menu #customColumnsSubMenu>\n  <ng-template *ngFor=\"let c of customColumns\" contextMenuItem passive=\"true\">\n    <div class=\"form-check form-switch\" style=\"min-height: auto;\" (click)=\"toggleColumn(c.id)\">\n      <input class=\"form-check-input\" [id]=\"c.id\" [checked]=\"!c.hidden\" type=\"checkbox\">\n      <label class=\"form-check-label\" [for]=\"c.key\">{{c.title}}</label>\n    </div>\n  </ng-template>\n</context-menu>\n\n\n<data-view-table-head #tableHeadElement\n  [columns]=\"columns\"\n  (columnsChange)=\"onColumnsChange($event)\"\n  (headClick)=\"onHeadClick($event)\"\n  [contextMenu]=\"columnsMenu\"\n  [style.minWidth.px]=\"tableWidth\">\n</data-view-table-head>\n\n\n<cdk-virtual-scroll-viewport\n  [itemSize]=\"itemSize\"\n  (scrolledIndexChange)=\"loadNextBatch($event)\"\n  class=\"viewport papers-scrollbar\">\n  <data-view-table-row\n    *cdkVirtualFor=\"let item of items; trackBy: trackByFn\"\n    [columns]=\"columns\"\n    [item]=\"item\"\n    [selected]=\"isItemSelected(item)\"\n    [highlighted]=\"isItemHighlighted(item)\"\n    [even]=\"isItemEven(item)\"\n    (click)=\"onClick($event, item)\"\n    (dblclick)=\"onDblClick($event, item)\"\n    (contextmenu)=\"onContextMenu($event, item)\">\n  </data-view-table-row>\n  <ng-content></ng-content>\n</cdk-virtual-scroll-viewport>\n", styles: [":host{display:flex;flex-direction:column;position:absolute;height:100%;width:100%}.viewport{height:100%;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { columns: [{
                type: Input
            }], itemSize: [{
                type: Input
            }], columnsChange: [{
                type: Output
            }], headClick: [{
                type: Output
            }], gridTableHead: [{
                type: ViewChild,
                args: [DataViewTableHeadComponent, { static: true }]
            }] } });

class ReadCubeDataViewModule {
    constructor(faConfig, faIconLibrary) {
        faConfig.defaultPrefix = 'fal';
        faIconLibrary.addIcons(faChevronUp, faChevronDown);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ReadCubeDataViewModule, deps: [{ token: i1$2.FaConfig }, { token: i1$2.FaIconLibrary }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: ReadCubeDataViewModule, declarations: [DataViewListComponent,
            DataViewListRowComponent,
            DataViewTableComponent,
            DataViewTableHeadComponent,
            DataViewTableRowComponent,
            ResizeHandleDirective,
            SortByFieldPipe], imports: [CommonModule,
            ScrollingModule,
            DragDropModule,
            NgbModule,
            ReadCubeContextMenuModule,
            FontAwesomeModule], exports: [DataViewListComponent,
            DataViewTableComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ReadCubeDataViewModule, imports: [CommonModule,
            ScrollingModule,
            DragDropModule,
            NgbModule,
            ReadCubeContextMenuModule,
            FontAwesomeModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ReadCubeDataViewModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        ScrollingModule,
                        DragDropModule,
                        NgbModule,
                        ReadCubeContextMenuModule,
                        FontAwesomeModule
                    ],
                    declarations: [
                        DataViewListComponent,
                        DataViewListRowComponent,
                        DataViewTableComponent,
                        DataViewTableHeadComponent,
                        DataViewTableRowComponent,
                        ResizeHandleDirective,
                        SortByFieldPipe
                    ],
                    exports: [
                        DataViewListComponent,
                        DataViewTableComponent
                    ],
                    providers: []
                }]
        }], ctorParameters: () => [{ type: i1$2.FaConfig }, { type: i1$2.FaIconLibrary }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DataViewListComponent, DataViewTableComponent, ReadCubeDataViewModule, debounce };
